/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Legend, Label, Tooltip, TooltipProps } from 'recharts';
import { IChart } from 'src/interfaces/chart';

import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { Loader, EmptyPieChart } from 'pg-ui-library';
import { Container, LegendSpan, TooltipBox } from './styles';

const CustomTooltip = ({ active, payload }: TooltipProps<ValueType, NameType>) => {
  if (active) {
    const name = payload ? payload[0].name : '';
    const value = payload ? payload[0].value : 0;

    return (
      <TooltipBox>
        <p className="label">{`${name} : $${value}`}</p>
      </TooltipBox>
    );
  }

  return null;
};

const LegendFormatter = (value: string) => <LegendSpan>{value}</LegendSpan>;

type PayHistoryChartProps = IChart & { isLoading: boolean };

const PayHistoryChart: React.FC<PayHistoryChartProps> = ({ data, isLoading }) => {
  const costs = data.map(item => item.value);
  const totalCost = costs
    .reduce((add, a) => add + a, 0)
    .toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });

  const empty: boolean = totalCost === '$0.00';

  return (
    <Container>
      {isLoading ? (
        <ResponsiveContainer maxHeight={200}>
          <Loader />
        </ResponsiveContainer>
      ) : (
        <ResponsiveContainer width="80%" maxHeight={200} aspect={2}>
          {!empty ? (
            <PieChart>
              <Legend
                verticalAlign="top"
                align="left"
                layout="vertical"
                iconType="square"
                iconSize={12}
                formatter={LegendFormatter}
              />
              <Tooltip content={<CustomTooltip />} />
              <Pie data={data} dataKey="value" nameKey="name" cx="60%" cy="40%" innerRadius="65%" fill="#8884d8">
                {data.map((entry, index) => (
                  <Cell key={index} fill={entry.color} />
                ))}
                <Label value={totalCost} position="center" fill="#1A1A32" fontFamily="BiotifMedium" fontSize={15} />
              </Pie>
            </PieChart>
          ) : (
            <EmptyPieChart />
          )}
        </ResponsiveContainer>
      )}
    </Container>
  );
};

export default PayHistoryChart;
